<template>
  <div class="flex flex-col items-center justify-start gap-1">
    <div class="relative">
      <img :class="[imageSize]" class="object-scale-down" :src="src" /><i
        :class="isGood ? 'el-icon-success text-greenG1' : 'el-icon-error text-redG3'"
        class="absolute top-px right-px text-xs"
      />
    </div>
    <div class="text-xs text-black">{{ $t(label) }}</div>
  </div>
</template>

<script>
export default {
  name: 'UploadSampleContainer',
  props: {
    imageSize: { type: String, required: true },
    label: { type: String, required: true },
    src: { type: String, required: true },
    isGood: { type: Boolean, default: true }
  }
};
</script>
